<template>
  <MglMarker
    ref="marker"
    :coordinates="coordinates"
    :draggable="false"
    :offset="[-10, -40]"
  >
    <template slot="marker">
      <div class="markerWrapper">
        <div :class="['marker', { isActive }]" />
      </div>
    </template>
  </MglMarker>
</template>

<script>
import { MglMarker } from 'vue-mapbox'

export default {
  name: 'CampaignModalPageGeoMapMarker',
  components: { MglMarker },
  props: {
    point: Object,
    isActive: Boolean,
  },
  computed: {
    coordinates() {
      const { longitude, latitude } = this.point.shape
      return [longitude, latitude]
    },
    color() {
      const color = this.isActive ? '#FF0F0F' : '#448aff'
      return color
    },
  },
}
</script>

<style scoped lang="scss">
.markerWrapper {
  position: relative;
}

.marker {
  box-sizing: content-box;
  position: absolute;
  top: 40%;
  left: 50%;
  border-radius: 50%;
  border: 8px solid #448aff;
  width: 8px;
  height: 8px;
  transition: border 0.2s;
  box-shadow: 6px 10px 5px -1px rgba(0, 0, 0, 0.32);

  &::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    bottom: -30px;
    left: -6px;
    border: 10px solid transparent;
    border-top: 17px solid #448aff;
    transition: border-top 0.2s;
  }

  &.isActive {
    border-color: #ff0f0f;

    &::after {
      border-top-color: #ff0f0f;
    }
  }
}
</style>
